<div class="tab-content" [class.loading]="isContentLoading">
  <i *ngIf="isContentLoading" class="fa-solid fa-spinner fa-spin tab-loading-spinner"></i>
  <ng-container *ngIf="!isContentLoading && canViewAccountSettings">
    <p class="double-margin-bottom">Manage your general Arpio account settings below.</p>
    <div class="margin-top flex gap-4 items-center">
      <h3 class="inline-heading">Account ID:</h3>
      <div>{{ accountService.accountId }}</div>
    </div>

    <div class="margin-top flex items-center gap-4 items-center">
      <h3 class="whitespace-nowrap">Account Name:</h3>
      <div *ngIf="canEditAccountName; else readOnlyAccountName" class="full-width">
        <form class="flex-center-row full-width" [formGroup]="accountNameModel" (ngSubmit)="updateAccountName()">
          <input id="account-name" formControlName="name" class="arpio-input space full-width" focus-element />
          <button
            type="submit"
            busy-button
            [busy]="updatingAccountName"
            [done]="updatedAccountName"
            class="arpio-button margin-left"
            [disabled]="saveNameDisabled"
            data-cy="update-account-name-button"
          >
            UPDATE
          </button>
        </form>
      </div>
    </div>
    <ng-template #readOnlyAccountName>
      <div>{{ accountDto?.name }}</div>
    </ng-template>

    <ng-container *ngIf="canDisplayEntitlementContent">
      <div class="margin-top flex gap-4 items-center">
        <h3 class="inline-heading">Product Edition:</h3>
        <div>{{ accountService.productEdition }}</div>
      </div>
      <ng-container *ngIf="canViewLicenseCount">
        <div class="margin-top">
          <div class="flex gap-4 items-center">
            <h3 class="inline-heading">License Count:</h3>
            <ng-container *ngIf="isOverLicensedBillableResourceCount; else underLicenseBlock">
              Current consumption of {{ currentBillableResourceCount }} billable resources exceeds licensed count of
              {{ licencedBillableResourceCount }}.
            </ng-container>
            <ng-template #underLicenseBlock>
              Consuming {{ currentBillableResourceCount }} of {{ licencedBillableResourceCount }} licensed billable
              resources.
            </ng-template>
          </div>
          <ng-container *ngIf="isLoadingReport; else reportLoadedBlock">
            <i class="fa-solid fa-spinner fa-spin"></i> Loading billable resources report...
          </ng-container>
          <ng-template #reportLoadedBlock>
            <ng-container *ngIf="this.reportRecordCountValue > 0">
              Download the <a href="{{ billableResourceReportUrlCsv() }}"> report of billable resources</a>.
            </ng-container>
          </ng-template>
        </div>
      </ng-container>

      <ng-container *ngIf="accountService.subscriptionExpired; else notExpiredBlock">
        <div class="margin-top flex gap-4 items-center">
          <h3 class="inline-heading">Subscription Status:</h3>
          <div>
            Expired on {{ accountService.subscriptionExpiration | date: 'shortDate' }}. Click
            <a target="_blank" [href]="accountService.marketplaceUrl">here</a> to purchase a new subscription.
          </div>
        </div>
      </ng-container>
      <ng-template #notExpiredBlock>
        <div class="margin-top flex gap-4 items-center">
          <h3 class="inline-heading">Subscription Expires:</h3>
          <div>{{ accountService.subscriptionExpiration | date: 'shortDate' }}</div>
        </div>
      </ng-template>
    </ng-container>
  </ng-container>
</div>
